import { render, staticRenderFns } from "./Map-4-rivers.vue?vue&type=template&id=46a54f91&"
import script from "./Map-4-rivers.vue?vue&type=script&lang=js&"
export * from "./Map-4-rivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports